import { useEffect, useState } from 'react';
import axios from 'axios';

const ContactInfo = (account, platform) => {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    if (!account || !platform) return;

    const fetchContact = async () => {
      try {
        const formData = new FormData();
        formData.append('type', '0');
        formData.append('account', account);
        formData.append('platform', platform);

        const res = await axios.post('https://system.yousrygroup.com/api_test/php/server.php', formData);

        console.log(res); // 👈 هنا نطبع البيانات المسترجعة
        

        const data = res.data;
        setContact(data); // 👈 فيها: ext, phone_call, whats_call, email, Instagram...
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };

    fetchContact();
  }, [account, platform]);

  return contact;
};

export default ContactInfo;
